import { Drawer, Tabs, Dropdown, Menu } from "antd";
import React, { useState } from "react";
import { useToggle, stringifyDate } from "../../modules";
import { useHistory, useParams } from "react-router-dom";
import images from "../../images";
import { useSnackbar } from "notistack";
import TabPane from "antd/lib/tabs/TabPane";
import Receive from "../reusable/receive";
import { useSelector } from "react-redux";
import { AiOutlineDown } from "react-icons/ai";
import Paragraph from "antd/lib/typography/Paragraph";


const EmployeeDetails = ({ path, onPerform }) => {
    const [employee, setEmployee] = useState()
    const [field, setField] = useState();
    const [val, setVal] = useState();
    const [vals, setVals] = useState([]);
    const [select, toggleSelect] = useToggle()
    const [visible, toggleVisible] = useToggle(true)
    const { user } = useSelector((state) => state.application);

    const history = useHistory()
    const {id} = useParams()

    const close = () => {
        toggleVisible()
        setTimeout(()=> history.goBack(), 300)
    }
  
    return ( 
      <Drawer
        maskClosable
        closable
        visible={visible}
        onClose={close}
        width="70%"
      >
        <Receive progress>
          {!employee ? (
            <>
              <div className="flex items-center px-2 py-3">
                <div className="h-28 flex items-center rounded-full justify-center overflow-hidden">
                  <img className="h-24 w-24 mx-auto" src={images.company_alt} />
                </div>
                <div className="w-9/12 flex items-center">
                  <div className="w-10/12 flex flex-col leading-none pl-4">
                    <p className="text-2xl font-semibold mb-0">
                      {employee?.name}
                    </p>
                    <p className="text-sm mb-0 font-semibold text-gray-700">
                      {employee?.phone?.join(", ")} -{" "}
                      {employee?.workEmail?.join(", ")}
                    </p>
                    <p className="text-sm mb-0 font-light text-gray-700">
                      Added on {stringifyDate(employee?.date)}
                    </p>
                  </div>
                  <div className="w-2/12">
                    <Dropdown
                      overlay={
                        <Menu>
                          <Menu.Item>Discard</Menu.Item>
                          <Menu.Item>Export</Menu.Item>
                        </Menu>
                      }
                    >
                      <button className="btn ml-2 py-2.1 hisani-btn-green-light text-white">
                        Actions <AiOutlineDown className="ml-2" />
                      </button>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <Tabs>
                <TabPane key="1" tab="Profile">
                  <p className="text-gray-500 font-bold text-xl my-0">
                    Employee Profile
                  </p>
                  <div className="grid md:grid-cols-2 sm:grid-cols-1 mt-3">
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Full Name
                      </label>
                      <Paragraph editable={"name"}>
                        {employee?.name ?? "John Doe"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Job Title
                      </label>
                      <Paragraph editable={"title"}>
                        {employee?.title ?? "Cashier"}
                      </Paragraph>
                    </div>
                    {/* <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Employee Id
                      </label>
                      <Paragraph editable={"id"}>
                        {employee?._id ?? "12345"}
                      </Paragraph>
                    </div> */}
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Date Of Birth
                      </label>
                      <Paragraph editable={"dob"}>
                        {employee?.dob ?? "2000/04/10"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        National ID Number
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.id ?? "293087"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Phone Number
                      </label>
                      <Paragraph editable={"phoneNo"}>
                        {employee?.phone ?? "0712345678"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Work Email
                      </label>
                      <Paragraph editable={"workEmail"}>
                        {employee?.wEmail ?? "employee@gmail.com"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Personal Email
                      </label>
                      <Paragraph editable={"personalEmail"}>
                        {employee?.pEmail ?? "employee@gmail.com"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Residential Country
                      </label>
                      <Paragraph editable={"country"}>
                        {employee?.country ?? "Kenya"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Residential Region
                      </label>
                      <Paragraph editable={"region"}>
                        {employee?.region ?? "Central"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Locality
                      </label>
                      <Paragraph editable={"locality"}>
                        {employee?.locality ?? "Kamangu"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4  text-gray-500 font-semibold mb-2">
                        Address
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.address ?? "254356"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1"></div>
                  </div>
                </TabPane>
                <TabPane key="2" tab="Education">
                  <p className="text-gray-500 font-bold text-xl my-0">
                    Education Details
                  </p>
                  <div className="grid md:grid-cols-2 sm:grid-cols-1 mt-3">
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Level Of Education
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.lvlEducation ?? "Degree"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Date Of Completion
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.doc ?? "2024/10/10"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1"></div>
                  </div>
                </TabPane>
                <TabPane key="3" tab="Payroll">
                  <p className="text-gray-500 font-bold text-xl my-0">
                    Details
                  </p>
                  <div className="grid md:grid-cols-2 sm:grid-cols-1 mt-3">
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Basic Salary
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.salary ?? "200,000"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Payment Frequency
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.paymentFreq ?? "Monthly"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Payment Method
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.payMethod ?? "Bank"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Bank Name
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.bankName ?? "CBK"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Bank Branch
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.bankBranch ?? "Nairobi"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Account Name
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.accName ?? "John Doh"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Account Number
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.accNumber ?? "254356"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1"></div>
                  </div>
                </TabPane>
                <TabPane key="4" tab="Contact Persons">
                  <p className="text-gray-500 font-bold text-xl my-0">
                    Details
                  </p>
                  <div className="grid md:grid-cols-2 sm:grid-cols-1 mt-3">
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Next of Kin
                      </label>
                      <span>Cashier Kamaa</span>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1"></div>
                  </div>
                </TabPane>
                <TabPane key="5" tab="Referees">
                  <p className="text-gray-500 font-bold text-xl my-0">
                    Details
                  </p>
                  <div className="grid md:grid-cols-2 sm:grid-cols-1 mt-3">
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Referer
                      </label>
                      <span>Cashier Kamaa</span>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1"></div>
                  </div>
                </TabPane>
                <TabPane key="6" tab="Roles and Permissions">
                  <p className="text-gray-500 font-bold text-xl my-0">
                    Details
                  </p>
                  <div className="grid md:grid-cols-2 sm:grid-cols-1 mt-3">
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Access Level
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.access ?? "cashier"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1"></div>
                  </div>
                </TabPane>
                <TabPane key="7" tab="Disciplinary Cases">
                  <p className="text-gray-500 font-bold text-xl my-0">
                    Details
                  </p>
                  <div className="grid md:grid-cols-2 sm:grid-cols-1 mt-3">
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1">
                      <label className="mr-4 text-gray-500 font-semibold mb-2">
                        Cases
                      </label>
                      <Paragraph editable={"idNo"}>
                        {employee?.cases ??
                          "Missed attendance of weekly meeting without prior notice"}
                      </Paragraph>
                    </div>
                    <div lassName="flex flex-col justify-between mb-1 px-1 pt-3 pb-1"></div>
                  </div>
                </TabPane>
                <TabPane key="8" tab="Exit Information"></TabPane>
              </Tabs>
            </>
          ) : null}
        </Receive>
      </Drawer>
    );
}

export default EmployeeDetails;